<template>
    <div>
        <div v-show="!saveOrUpdate.visible&&!look.visible" class="el-img">
            <!--搜索表单-->
            <div class="search-box selectType">
                <el-form ref="searchForm" :rules="rules"  :inline="true" :model="searchForm" >
                    <el-form-item label="注册年份:" prop="year">
                        <el-date-picker
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择注册年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="考生姓名:" prop="name">
                        <el-input size="mini" v-model="searchForm.name" placeholder="请输入考生姓名"></el-input>
                    </el-form-item>
                  <el-form-item label="考生类型:" prop="studentType">
                    <el-input size="mini" v-model="searchForm.studentType" placeholder="请输入考生类型"></el-input>
                  </el-form-item>
                     <el-form-item label="身份证号:" prop="idCard">
                        <el-input size="mini" v-model="searchForm.idCard" placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input size="mini" maxlength="32" placeholder="请输入备注"  show-word-limit  v-model="searchForm.remark" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业学校" prop="univerColleges">
                        <el-input size="mini" v-model="searchForm.univerColleges" placeholder="请输入毕业学校"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业学校编码" prop="unicerCollegesCode">
                        <el-input size="mini" v-model="searchForm.unicerCollegesCode" placeholder="请输入毕业学校编码"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业专业" prop="studyMajor">
                        <el-input size="mini" maxlength="32" placeholder="请输入毕业专业"  show-word-limit  v-model="searchForm.studyMajor" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="报考专业" prop="majorId">
                        <el-select v-model="searchForm.majorId" size="mini" filterable  placeholder="请选择报考专业">
                            <el-option v-for="item in majorList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态" prop="status">
                        <el-select v-model="searchForm.status" size="mini" filterable  placeholder="请选择审核状态">
                            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="资格审核状态" prop="uploadStatus">
                        <el-select v-model="searchForm.uploadStatus" size="mini" filterable  placeholder="请选择资格审核状态">
                            <el-option v-for="item in statusUploadList" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudent-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh-left" @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysStudent-save icon="el-icon-plus" @click="toSaveOrUpdate" >新增</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysStudent-batchUpdate icon="el-icon-edit" @click="showBatchSaveOrUpdate" >批量修改</el-button>
                        <el-dropdown>
                            <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-tooltip class="item" effect="dark" content="审核通过的不允许删除，如有勾选系统后台自动会过滤" placement="top-start">
                                    <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudent-batchDelete icon="el-icon-delete" @click="batchDelete" >批量删除</el-button></el-dropdown-item>
                                </el-tooltip>
                                <!--<el-dropdown-item><el-button size="mini" type="text" v-display:sysStudent-leadingIn icon="el-icon-upload" @click="leadingInsysStudent">导入</el-button></el-dropdown-item>-->
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudent-leadingInCode icon="el-icon-upload" @click="leadingInsysStudentCode">导入报名号</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudent-export icon="el-icon-download" @click="exportsysStudent">导出</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudent-exportModule icon="el-icon-download" @click="exportsysStudentModule('upsertForm')">下载模板</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudent-batchResetPwd icon="el-icon-refresh" @click="batchResetPwd">批量重置密码</el-button></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
             </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" :data="tableData" @selection-change="changeFun"   @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sequence" label="序号" width="70px" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态" width="60px" >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="statusMap[scope.row.status]" placement="top-start">
                            <span :class="statusMapIcon[scope.row.status]" :style="{'color':statusMapColor[scope.row.status],'font-size':'24px'}"></span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="uploadStatus" label="资格审查状态" width="60px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.uploadStatus=='-1'">未上传</span>
                        <span v-else :style="{'color':statusUploadMapColor[scope.row.uploadStatus]}">{{statusUploadMap[scope.row.uploadStatus]}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="faceImg" label="头像" width="80px">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.faceImg" style="width: 50px; height: 50px;border-radius: 100%" :src="config.resPre+scope.row.faceImg" :preview-src-list="[config.resPre+scope.row.faceImg]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="ticketNumber" label="准考证号" width="130"></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="考生姓名"></el-table-column>
              <el-table-column show-overflow-tooltip prop="studentType" label="考生类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sex" label="性别" width="50"></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCard" label="身份证号" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="联系电话" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="address" label="联系地址" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="univerColleges" label="毕业学校" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studyMajor" label="毕业专业" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endSchoolCode" label="毕业证书编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajor" label="报考专业" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="code" label="报名号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sumScore" label="总分"></el-table-column>
                <el-table-column show-overflow-tooltip prop="level" label="专业排名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable></el-table-column>
                <el-table-column fixed="right" label="操作" width="80"  >
                    <template slot-scope="scope">
                        <el-dropdown>
                            <span class="el-dropdown-link" style="color: #409EFF">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><el-button type="text" v-display:sysStudent-update @click="toSaveOrUpdate($event,scope.row.id)">修改</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysStudent-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                                <el-tooltip class="item" effect="dark" v-if="scope.row.status!=1" content="一旦删除学生，相关信息也会被删除，请谨慎操作" placement="top-start">
                                    <el-dropdown-item><el-button type="text" v-display:sysStudent-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" v-else  content="审核通过不允许删除" placement="top-start">
                                    <el-dropdown-item><el-button type="text" v-display:sysStudent-delete disabled>删除</el-button></el-dropdown-item>
                                </el-tooltip>
                                <el-dropdown-item><el-button type="text" v-display:sysStudent-resetPwd plain @click="resetPwd(scope.row.id)">重置密码</el-button></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
            <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
                <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <!--表格-->
                <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column show-overflow-tooltip prop="errorMsg" label="导入备注" width="200">
                        <template slot-scope="scope">
                            <span style="color: red">{{scope.row.errorMsg}}</span>
                        </template>
                    </el-table-column>
                        <el-table-column prop="name" label="考生姓名"></el-table-column>
                        <el-table-column prop="idCard" label="身份证号"></el-table-column>
                        <el-table-column prop="phone" label="联系电话"></el-table-column>
                        <el-table-column prop="ticketNumber" label="准考证号"></el-table-column>
                        <el-table-column prop="examMajor" label="报考专业"></el-table-column>
                        <el-table-column prop="code" label="报名号"></el-table-column>
                </el-table>
            </div>
                <div v-if="dialogExcel.title=='导入' || dialogExcel.title=='导入报名号' ">
                    <el-upload class="lead-in-th"
                               style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                               :action="uploadUrl"
                               :headers="headers"
                               multiple
                               :show-file-list="false"
                               :data='{"type":dialogExcel.type}'
                               :on-success="handlesysStudentSuccess"
                               :before-upload="beforesysStudentUpload">
                        <div class="" style="width: 440px;height: 50px;">导入</div>
                    </el-upload>
                    <div class="lead-in-th" @click="exportsysStudentModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :model="batchUpdateForm" title="批量修改"   width="650px" :visible.sync="batchSaveVisible">
                <el-form class="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                    <el-form-item label="备注" prop="remark">
                        <el-input size="mini" v-model="batchUpdateForm.remark" maxlength="255" style="width: 455px" show-word-limit placeholder="请输入备注" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="batchSaveVisible = false">取 消</el-button>
                    <el-button size="mini" type="primary"  @click="batchSaveOrUpdate(batchUpdateForm)">确 定</el-button>
                </div>
            </el-dialog>

        </div>
        <save-or-update-sys-student v-if="saveOrUpdate.visible" v-bind="saveOrUpdate" @closeSaveOrUpdate="closeSaveOrUpdate"></save-or-update-sys-student>
        <look-sys-student v-if="look.visible" v-bind="look" :visible.sync="look.visible"></look-sys-student>

    </div>
</template>

<script>
    import axios from 'axios';
    import saveOrUpdateSysStudent from './saveOrUpdateSysStudent';
    import lookSysStudent from './lookSysStudent';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import md5 from 'md5';
    export default {
        name: "sysStudent",
        components:{saveOrUpdateSysStudent,lookSysStudent,noData},
        data() {
            return {
                searchForm:{
                      sequence: '',
                      studentId: '',
                      name: '',
                      idCard: '',
                      birthday: '',
                      sex: '',
                      nation: '',
                      politicalAffiliation: '',
                      faceImg: '',
                      phone: '',
                      emergencyContact:'',
                      emergencyPhone:'',
                      adressCode: '',
                      address: '',
                      ticketNumber: '',
                      password: '',
                      univerColleges: '',
                      unicerCollegesCode: '',
                      studyColleges: '',
                      studyCollegesCode: '',
                      studyMajor: '',
                      examMajor: '',
                      studyCode: '',
                      reward: '',
                      speciality: '',
                      remark: '',
                      studySequence: '',
                      status: '',
                      examineName: '',
                      examineTime: '',
                      examineRemark: '',
                      updateTime: '',
                      createTime: '',
                      uploadStatus:'',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'name,idCard,phone,studyMajor,univerColleges,unicerCollegesCode,remark,studentType'
                    }
                },
                tableData: [],
                saveOrUpdate:{
                    visible:false,
                    title:'增加',
                    id:''
                },
                look:{
                    visible:false,
                    id:''
                },
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysStudent/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入',
                    type:''
                },
                upsertForm:{
                  id:'',
                  password:'',
                },
                rules: {
                  sequence: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  studentId: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  name: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  idCard: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  birthday: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  sex: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  nation: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  politicalAffiliation: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  faceImg: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  phone: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                    emergencyContact: [
                        { required: true, message: '请输入紧急联系', trigger: 'blur' },
                    ],
                    emergencyPhone: [
                        { required: true, message: '请输入紧急联系', trigger: 'blur' },
                    ],
                  adressCode: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  address: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  ticketNumber: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  password: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  univerColleges: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  unicerCollegesCode: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  studyColleges: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  studyCollegesCode: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  studyMajor: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  examMajor: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  studyCode: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  reward: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  speciality: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  remark: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  studySequence: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  status: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  examineName: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  examineTime: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  examineRemark: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  updateTime: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  createTime: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                },
                statusMap:["已报名（待审核）","审核通过","审核不通过"],
                statusMapIcon:["el-icon-warning","el-icon-success","el-icon-error"],
                statusMapColor:["#5561ff","#79ff25","#ff4520"],
                config:config,
                yearList:[],
                univerCollegesList:[],
                majorList:[],
                statusUploadMap:["未上传完","已提交（待审核）","审核通过","审核不通过"],
                statusUploadMapColor:["#E6A23C","#E6A23C","#67C23A","#F56C6C","#E6A23C","#67C23A","#F56C6C"],
                statusList:[
                    {"name":"已报名（待审核）","value":"0"},
                    {"name":"审核通过","value":"1"},
                    {"name":"审核不通过","value":"2"},
                ],
                statusUploadList:[
                    {"name":"未上传","value":"-1"},
                    {"name":"未上传完","value":"0"},
                    {"name":"已提交（待审核）","value":"1"},
                    {"name":"审核通过","value":"2"},
                    {"name":"审核不通过","value":"3"},
                ],
                batchSaveVisible:false,
                batchUpdateForm:{
                    remark:'',
                    rowData:[],
                }

            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getDdUniverAndMajorList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            toSaveOrUpdate($event,id){
                if(id){
                    this.saveOrUpdate.title='修改';
                    this.saveOrUpdate.id=id;
                }else{
                    this.saveOrUpdate.title='增加';
                }
                this.saveOrUpdate.visible=true;
            },
            closeSaveOrUpdate(data){
                this.saveOrUpdate.visible=false;
                data&&this.submit();
            },
            toLook($event,id){
                this.look={
                    visible:true,
                    id:id
                }
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysStudent/deleteSysStudent/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })

                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysStudent/findSysStudentsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            leadingInsysStudent() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
                this.dialogExcel.type=1;
            },
            leadingInsysStudentCode(){
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入报名号';
                this.dialogExcel.type=2;
            },
            exportsysStudent() {
                axios({
                    url: `${home}/sysStudent/exportSysStudent`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "学生信息列表.xls");
                });
            },
            exportsysStudentModule() {
                axios({
                    url: `${home}/sysStudent/exportSysStudentModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "学生信息导入模板.xls");
                });

            },
            handlesysStudentSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforesysStudentUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                        axios({
                            url: `${home}/sysStudent/batchDeleteSysStudent`,
                            method: "post",
                            data: {
                                rowData: this.rowData
                            }
                        })
                            .then(res => {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                this.submit();
                            })
                            .catch(error => {});
                    })
                    .catch(() => {
                        this.$message({
                            type: "error",
                            message: "删除失败!"
                        });
                    });
            },
            resetPwd(id) {
                this.$confirm("确认重置改学生的登录密码吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudent/resetPwd/${id}`,
                        method: 'GET',
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '重置成功，密码为该学生的身份证号后四位!'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(()=>{
                    this.$message({
                        type: 'info',
                        message: '取消重置'
                    });
                });
            },
            batchResetPwd() {
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认重置勾选学生的登录密码吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysStudent/batchResetPwd`,
                        method: 'POST',
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '批量重置成功，密码为学生的身份证号后四位!'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消重置'
                    });
                });
            },
            getYearList(){
                axios({
                    url: `${home}/sysDdList/getStudentYear`,
                    method: "GET",
                }).then(res => {
                    this.yearList = res.data;
                });
            },
            getDdUniverAndMajorList(){
                axios({
                    url:`${home}/sysDdList/getDdUniverAndMajorList`,
                    method:'GET'
                }).then(res=>{
                    this.univerCollegesList = res.data;
                    this.majorList = res.data2;
                }).catch(error=>{

                })
            },
            showBatchSaveOrUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }else{
                    this.batchSaveVisible = true;
                }
            },
            batchSaveOrUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.batchUpdateForm.rowData = this.rowData;
                    axios({
                        url:`${home}/sysStudent/batchUpdateSysStudent`,
                        method:'POST',
                        data:this.batchUpdateForm
                    }).then(res=>{
                        this.batchSaveVisible = false;
                        this.submit();
                        this.$refs['batchUpdateForm'].resetFields();
                    }).catch(error=>{

                    })
                })
            }

        }
    }
</script>
<style lang="scss">
    .selectType{
        .el-input__inner{
            width: 150px;
        }
        .el-input .el-input--mini {
            width: 150px;
        }
        .el-input-number{
            width: 150px;
        }
        .el-date-editor{
            width: 150px;
        }
    }
    .el-img{
        .el-image__inner{
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
    }
</style>
